import { Fragment } from 'react';

import { ContactAvatar, TeamUserAvatar } from '@poseidon/components/Avatar';
import { cn } from '@poseidon/components/cn';

import type { HistoryStepPerson } from '~/components/Sequence/sequenceHistory';

interface Props {
  people: HistoryStepPerson[];
}

/** The ring that separates overlapping faces, in the canvas's own colour (as the graph's people-piles do). */
const FACE = 'size-6 rounded-full ring-2 ring-slate-50 dark:ring-neutral-900';

/**
 * The faces of whoever is on a history entry — the contact, or you / a teammate — overlapping when a
 * conversation has both sides, the newest speaker last (on top). Each falls back to initials.
 */
export function SequenceHistoryFaceStack({ people }: Props) {
  return (
    <>
      {people.map((person, k) => (
        <Fragment key={person.kind === 'contact' ? 'contact' : `rep:${person.userId}`}>
          {person.kind === 'contact' && (
            <ContactAvatar
              data-face="contact"
              firstName={person.firstName}
              lastName={person.lastName}
              imageSrc={person.pictureUrl}
              shape="circle"
              className={cn(FACE, k > 0 && '-ml-2')}
            />
          )}
          {person.kind === 'rep' && (
            <TeamUserAvatar
              data-face="rep"
              userTeam={{ name: person.name, profilePicture: person.pictureUrl }}
              shape="circle"
              className={cn(FACE, k > 0 && '-ml-2')}
            />
          )}
        </Fragment>
      ))}
    </>
  );
}
